var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var BetBtn = /** @class */ (function (_super) {
    __extends(BetBtn, _super);
    function BetBtn(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonRef = React.createRef();
        _this.timeout = 0;
        _this.oddsDefaultClass = "rj-ev-list__bet-btn--odd-init";
        _this.oddsUpClass = "rj-ev-list__bet-btn--odd-up";
        _this.oddsDownClass = "rj-ev-list__bet-btn--odd-down";
        _this.chosenClass = "rj-ev-list__bet-btn--chosen";
        _this.removeOddsClassDuration = 1600;
        _this.btnClass = _this.oddsDefaultClass;
        return _this;
    }
    BetBtn.prototype.noop = function () { return false; };
    BetBtn.prototype.fnRouter = function (handler) {
        return (typeof handler !== "function" ? this.noop : handler)();
    };
    BetBtn.prototype.setOddsClass = function (prevProps, props) {
        if (this.buttonRef && this.buttonRef.current) {
            this.buttonRef.current.classList.remove(this.btnClass);
            this.btnClass = this.getOddsClass(prevProps, props);
            this.buttonRef.current.classList.add(this.btnClass);
        }
    };
    BetBtn.prototype.getOddsClass = function (prevProps, props) {
        return props.trueOdds > prevProps.trueOdds ? this.oddsUpClass : this.oddsDownClass;
    };
    BetBtn.prototype.removeOddsClass = function () {
        if (this.buttonRef && this.buttonRef.current) {
            this.buttonRef.current.classList.remove(this.btnClass);
            this.btnClass = this.oddsDefaultClass;
            this.buttonRef.current.classList.add(this.btnClass);
        }
    };
    BetBtn.prototype.updateOddsClass = function (prevProps, props) {
        if (typeof props.trueOdds === "undefined") {
            return false;
        }
        else {
            if (prevProps.trueOdds !== props.trueOdds) {
                clearTimeout(this.timeout);
                this.setOddsClass(prevProps, props);
                this.timeout = setTimeout(this.removeOddsClass.bind(this), this.removeOddsClassDuration);
                return true;
            }
            return false;
        }
    };
    BetBtn.prototype.shouldRenderText = function () {
        return this.props.text ? true : false;
    };
    BetBtn.prototype.shouldRenderPoints = function () {
        return typeof this.props.point === "string"
            && this.props.point.length !== 0;
    };
    BetBtn.prototype.shouldRenderOdds = function () {
        return this.props.trueOdds !== 0
            && !this.shouldBeDisabled();
    };
    BetBtn.prototype.renderText = function () {
        return this.shouldRenderText()
            && React.createElement("span", { className: "rj-ev-list__bet-btn__content rj-ev-list__bet-btn__text", "data-uat": "ev-list-ev-list-bet-btn-text" }, this.props.text);
    };
    BetBtn.prototype.renderPoints = function () {
        return this.shouldRenderPoints()
            && React.createElement("span", { className: "rj-ev-list__bet-btn__content rj-ev-list__bet-btn__point", "data-uat": "ev-list-ev-list-bet-btn-point" }, this.props.point);
    };
    BetBtn.prototype.renderOdds = function () {
        return this.shouldRenderOdds()
            && React.createElement("span", { className: "rj-ev-list__bet-btn__content rj-ev-list__bet-btn__odd", "data-uat": "ev-list-ev-list-bet-btn-odd" }, this.props.odd);
    };
    BetBtn.prototype.renderContent = function () {
        return (React.createElement("div", { className: "rj-ev-list__bet-btn__inner", "data-uat": "ev-list-ev-list-bet-btn-inner" },
            this.renderText(),
            this.renderPoints(),
            this.renderOdds()));
    };
    BetBtn.prototype.renderArrows = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "rj-ev-list__bet-btn__arrow-up" }),
            React.createElement("span", { className: "rj-ev-list__bet-btn__arrow-down" })));
    };
    BetBtn.prototype.componentDidUpdate = function (prevProps) {
        this.updateOddsClass(prevProps, this.props);
    };
    BetBtn.prototype.shouldBeDisabled = function () {
        return (this.props.hideLowOdds && this.containsZeroOdds()) ? true : false;
    };
    BetBtn.prototype.containsZeroOdds = function () {
        return this.props.trueOdds
            && this.props.trueOdds >= 0.001
            && this.props.trueOdds < 1.01;
    };
    BetBtn.prototype.render = function () {
        var btnClass = "rj-ev-list__bet-btn " + (this.props.classNames ? this.props.classNames : "");
        return (React.createElement("button", { ref: this.buttonRef, className: btnClass, onClick: this.fnRouter.bind(this, this.props.handler), disabled: this.props.isDisabled || this.shouldBeDisabled(), "data-uat": "button-ev-list-bet-btn" },
            this.renderContent(),
            this.renderArrows()));
    };
    return BetBtn;
}(React.PureComponent));
export { BetBtn };
//# sourceMappingURL=BetBtn.js.map